const STAGE = process.env.STAGE || 'prod';

const localBaseUrl = 'http://localhost:8080';
const testBaseUrl = 'https://test1.myalice.com';
const prodBaseUrl = 'https://app.myalice.com';

let API_BASE_URL = process.env.API_BASE_URL || prodBaseUrl;
if (STAGE === 'test') {
  API_BASE_URL = testBaseUrl;
} else if (STAGE === 'dev') {
  API_BASE_URL = localBaseUrl;
}

const config = {
  API_BASE_URL,
  STAGE,
  APP_VERSION: '7.2.0',
};

export default config;
